import { z } from "zod";

export const addressBookHistoryItemSchema = z.object({
	addressBookItemId: z.number(),
	stopName: z.string().nullable().optional(),
	companyName: z.string().nullable(),
	address1: z.string(),
	address2: z.string().nullable(),
	postalCode: z.string().nullable(),
	city: z.string().nullable(),
	stateProvince: z.string().nullable(),
	country: z.string(),
	createdDate: z.string(),
	createdByCustomerId: z.number().nullable(),
	createdByInternalId: z.number().nullable(),
	createdByInternalEmail: z.string().nullable(),
	createdByInternalName: z.string().nullable(),
	isLTL: z.boolean(),
	isAR: z.boolean(),
	isValidated: z.boolean().nullable(),
	legacyAddressId: z.number().nullable(),
	customerId: z.number(),
	validFrom: z.string(),
	validTo: z.string(),
});

export const addressBookHistoryDetailSchema = z.object({
	contactDetailId: z.number(),
	addressBookItemId: z.number(),
	contactName: z.string(),
	contactPhone: z.string().nullable(),
	contactExtension: z.string().nullable(),
	hoursOpen: z.string().nullable(),
	hoursClose: z.string().nullable(),
	stopType: z.number(),
	mode: z.number(),
	timeZone: z.string().nullable(),
	specialInstructions: z.string().nullable(),
	accessorials: z.string().nullable(),
	validFrom: z.string(),
	validTo: z.string(),
	createdByCustomerId: z.number().nullable().optional(),
	createdByInternalId: z.number().nullable().optional(),
	createdByInternalEmail: z.string().nullable().optional(),
	createdByInternalName: z.string().nullable().optional(),
	isLTL: z.boolean().optional(),
	isAR: z.boolean().optional(),
});

export const addressBookHistorySchema = z.object({
	itemHistory: z.array(addressBookHistoryItemSchema),
	detailHistory: z.array(addressBookHistoryDetailSchema),
});

export type AddressBookHistoryItem = z.infer<
	typeof addressBookHistoryItemSchema
>;

export type AddressBookHistoryDetail = z.infer<
	typeof addressBookHistoryDetailSchema
>;

export type AddressBookHistoryResponse = z.infer<
	typeof addressBookHistorySchema
>;
